import { Component, Input } from '@angular/core';

@Component({
  selector: 'value-drivers',
  templateUrl: 'value-drivers.html'
})
export class ValueDriversComponent {

  @Input() valueDrivers: any;

  constructor() {
  }

  populateFields(form, valueType, startPoint, endPoint) {
    const valueTypeToChange = this.valueDrivers[valueType];
    endPoint = endPoint || valueTypeToChange.length;

    for (let i = startPoint; i < endPoint; i++) {
      valueTypeToChange[i].value = form.value[valueType] / 100;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/value-drivers/value-drivers.ts